import { cx } from "@light-technology/components";
import { BatteryFull, Car02 } from "@untitledui/icons";
import { ProgramType } from "../state/api.types";

type ProgramTypeIconProps = {
  programType: ProgramType;
  className?: string;
};

export const ProgramTypeIcon = ({
  programType,
  className,
}: ProgramTypeIconProps) => {
  switch (programType) {
    case ProgramType.Battery:
      return <BatteryFull className={cx("size-5 rotate-270", className)} />;
    case ProgramType.Evcharging:
      return <Car02 className={cx("size-5", className)} />;
    default:
      return null;
  }
};
